// extracted by mini-css-extract-plugin
export default {"divAbsolute":"style_divAbsolute__WprwJ","divSpinner":"style_divSpinner__6Dv2D","spinner":"style_spinner__RYVoL","spinnerText":"style_spinnerText__t7ss5"};